import React, { FC, PropsWithChildren, ReactNode } from 'react'
import { Header } from '../header/Header'
import { graphql } from 'gatsby'
import { Footer } from '../footer/Footer'
import { Locale } from '../../common/intl/Locale'

export const AppLayout: FC<
  PropsWithChildren<{
    below?: ReactNode
    locales?: Locale[]
  }>
> = ({ children, below, locales }) => {
  return (
    <>
      <div className="flex">
        <div className="h-screen w-0" />

        <div className="min-h-full grow overflow-auto">
          <Header />

          {children}
        </div>
      </div>

      {below}

      <Footer locales={locales} />
    </>
  )
}

export const AppLayoutMessages = graphql`
  fragment AppLayoutMessages on Messages {
    feedback {
      title
    }
    webcam {
      name
      title
    }
    mic {
      name
      title
    }
    headphones {
      name
      title
    }
  }
`
